import { Resolutions } from '../../enums/Resolutions';

function getWindowDimensions() {
  const { outerWidth: width, outerHeight: height } = window;
  return {
    width,
    height,
  };
}

type isMobileDeviceAndLandscape = {
  isMobileDevice: boolean;
  isTabletDevice: boolean;
  isLandscape: boolean;
};

export const checkMobileDevice = (): isMobileDeviceAndLandscape => {
  const { width } = getWindowDimensions();

  const isTablet = checkTabletDevice();

  if (navigator.userAgent.match(/iPhone/i)) {
    return {
      isMobileDevice: true,
      isTabletDevice: isTablet,
      isLandscape: window.matchMedia('(orientation: landscape)').matches,
    };
  }
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    (width < Resolutions.Tablet &&
      window.matchMedia('(orientation: portrait)') &&
      !(navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Macintosh/i))) //For iPad Mini
  ) {
    if (
      (window.matchMedia('(orientation: portrait)').matches &&
        window.innerWidth >= Resolutions.Tablet) ||
      (window.matchMedia('(orientation: landscape)').matches &&
        window.innerHeight > Resolutions.MobileLandscape)
    ) {
      return {
        isMobileDevice: false,
        isTabletDevice: isTablet,
        isLandscape: window.matchMedia('(orientation: landscape)').matches,
      };
    }

    return {
      isMobileDevice: true,
      isTabletDevice: isTablet,
      isLandscape: window.matchMedia('(orientation: landscape)').matches,
    };
  }
  return {
    isMobileDevice: false,
    isTabletDevice: isTablet,
    isLandscape: false,
  };
};

const checkTabletDevice = (): boolean => {
  const { width } = getWindowDimensions();

  if (
    navigator.userAgent.match(/iPad/i) ||
    ((navigator.platform === 'MacIntel' || navigator.platform === 'Macintosh') &&
      navigator.maxTouchPoints > 2) ||
    (((window.matchMedia('(orientation: portrait)').matches &&
      window.innerWidth >= Resolutions.Tablet) ||
      (window.matchMedia('(orientation: landscape)').matches &&
        window.innerHeight > Resolutions.MobileLandscape)) &&
      width < Resolutions.Desktop)
  ) {
    return true;
  }
  return false;
};
